import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { RegistrationCodes } from '../../models/registrationCodes';
import RegistrationService from '../../services/registrationService';
import User from '../../models/user';
import CompareTwoInputsValidator from '../../validators/compareTwoInputsValidator';
import PasswordRulesValidator from '../../validators/passwordRulesValidator';
import UsernameAlreadyExistValidator from '../../validators/usernameAlreadyExistValidator';
import { MessageQueService } from '../../services/index';

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.scss'],
  providers: [RegistrationService, MessageQueService]
})

export default class RegistrationComponent implements OnInit {

  constructor(private router: Router, private msgSvc: MessageQueService, private registrationService: RegistrationService, private formBuilder: FormBuilder) { }

  ngOnInit() {
    this.msgSvc.setControlKey();
    this.registrationForm = this.formBuilder.group({
        token: ['', Validators.required],
        user: this.formBuilder.group({
          userName: ['', [
              Validators.required,
              Validators.minLength(6),
              Validators.maxLength(30),
              UsernameAlreadyExistValidator(),
            ]
          ],
          email: ['', [
            Validators.required,
            Validators.email,
            Validators.maxLength(255),
            CompareTwoInputsValidator('username', false)
          ]
        ],
          password: ['', [
              Validators.required,
              Validators.maxLength(60),
              PasswordRulesValidator()
            ]
          ],
          confirmPassword: ['', [
              Validators.required,
              Validators.maxLength(60),
              CompareTwoInputsValidator('password')
            ]
          ],
          firstName: ['', [
              Validators.required,
              Validators.maxLength(255),
            ]
          ],
          middleName: ['', Validators.maxLength(255)],
          lastName: ['', [
              Validators.required,
              Validators.maxLength(255),
            ]
          ],
          phoneNumber: ['', Validators.maxLength(255)],
      })
    });
  }

  onSubmit() {
    const form = this.registrationForm.value;
    const user: User = Object.assign({}, form.user, { confirmPassword: undefined });
    this.registrationService.registerUser(user, form.token as string)
      .subscribe((registrationCodes: RegistrationCodes[]) => {

        const code = registrationCodes.find((rc: RegistrationCodes) => rc === RegistrationCodes.ok);

        if (code === RegistrationCodes.ok) {
          this.router.navigate(['confirmation']);
        } else {
          for (const registrationCode of registrationCodes) {
            switch (registrationCode) {
              case RegistrationCodes.requireUsername:
                this.setValidationErrorByControlName('token', 'required');
                break;
              case RegistrationCodes.tokenNotValid:
                this.setValidationErrorByControlName('token', 'tokenNotValid');
                break;
              case RegistrationCodes.invalidUsername:
              case RegistrationCodes.requireUsername:
                this.setValidationErrorByControlName('user.userName', 'required');
                break;
              case RegistrationCodes.invalidPassword:
              case RegistrationCodes.requirePassword:
                this.setValidationErrorByControlName('user.password', 'required');
                break;
              case RegistrationCodes.invalidFirstName:
                this.setValidationErrorByControlName('user.firstName', 'required');
                break;
              case RegistrationCodes.invalidLastName:
                this.setValidationErrorByControlName('user.lastName', 'required');
                break;
              case RegistrationCodes.usernameAlreadyExist:
                this.setValidationErrorByControlName('user.userName', 'usernameAlreadyExist');
                break;
              case RegistrationCodes.userAndEmailAreTheSame:
                this.setValidationErrorByControlName('user.email', 'compareTwoInputs');
                break;
              default:
                break;
            }
          }
        }
      });
  }

  setBlurById(id: string) {
    const classListPasswordSidebar = document.getElementById(id).classList;
    classListPasswordSidebar.remove('show-sidebar');
    classListPasswordSidebar.add('hide-sidebar');
  }

  setFocusById(id: string) {
    const classListPasswordSidebar = document.getElementById(id).classList;
    classListPasswordSidebar.remove('hide-sidebar');
    classListPasswordSidebar.add('show-sidebar');
  }
  passwordKeyup(event: any) {
    const password: string = event.target.value;
    this.checkLength(password);
    this.checkRegEx(password, /[!@#$%^&*(){}[\]?~<>]/, 'password-symbol-rule');
    this.checkRegEx(password, /[A-Z]/, 'password-upper-case-letter');
    this.checkRegEx(password, /[a-z]/, 'password-lower-case-letter');
    this.checkRegEx(password, /\d/, 'password-number-rule');
  }

  private checkRegEx(s: string, pattern: RegExp, id: string) {
    const isMatch = s.match(pattern);
    if (!isMatch) {
      this.showRuleNotMet(id);
    } else {
      this.showRuleMet(id);
    }
  }

  private checkLength(password: string) {
    const id = 'password-length-rule';
    if (password.length < 8) {
      this.showRuleNotMet(id);
    } else {
      this.showRuleMet(id);
    }
  }

  private showRuleMet(id: string) {
    const passwordLength = document.getElementById(id).classList;
    passwordLength.remove('rule-not-met');
    passwordLength.add('rule-met');
  }

  private showRuleNotMet(id: string) {
    const passwordLength = document.getElementById(id).classList;
    passwordLength.remove('rule-met');
    passwordLength.add('rule-not-met');
  }

  private setValidationErrorByControlName(controlName: string, validatorType: string) {
    const control = this.registrationForm.get(controlName);
    const validator = {};
    validator[validatorType] = true;
    control.setErrors(validator);
    control.markAsTouched();
  }

  get userName() { return this.registrationForm.get('user.userName'); }
  get email() { return this.registrationForm.get('user.email'); }
  get password() { return this.registrationForm.get('user.password'); }
  get confirmPassword() { return this.registrationForm.get('user.confirmPassword'); }
  get firstName() { return this.registrationForm.get('user.firstName'); }
  get middleName() { return this.registrationForm.get('user.middleName'); }
  get lastName() { return this.registrationForm.get('user.lastName'); }
  get phoneNumber() { return this.registrationForm.get('user.phoneNumber'); }
  get token() { return this.registrationForm.get('token'); }

  registrationForm: FormGroup;

}



// WEBPACK FOOTER //
// ./src/app/registration/registration.component.ts